export default function unescape(value) {
    const template = document.createElement('template');
    template.innerHTML = value ?? '';

    return template.innerHTML;
}
